'use client'
import React from 'react'

export const HorizontalRuleIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="icon"
    fill="none"
    focusable="false"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="currentColor" height="1" width="12" x="4" y="9.5" />
  </svg>
)
